// Shared across Avatar instances so a broken URL is only requested once per session.
export const failedAvatarUrls = new Set();
